import "../theme/scss/index.scss";
import ReduxProvider from "../store/reduxProvider";
import {usePathname} from "next/navigation";
import {AntdConfigProvider} from "@/provider";
import {MainLayout} from "@/theme/layout";
import {ReactQueryDevtools} from "react-query/devtools";
import {QueryClient, QueryClientProvider} from "react-query";
import {SessionProvider} from "next-auth/react";

const queryClient = new QueryClient({
    defaultOptions:{
        queries:{
            refetchOnWindowFocus: false,
        },
    }
})

const authRoutes = ['/sign-in']

export default function MyApp({ Component, pageProps: { session, ...pageProps },}) {
    const pathname = usePathname()

    return (
       <>
           <main className={`main`}>
               <ReduxProvider>
                   <QueryClientProvider client={queryClient}>
                       <SessionProvider session={session}>
                           <AntdConfigProvider>
                               {(authRoutes.includes(pathname))
                                   ? (
                                       <>
                                           <Component {...pageProps}/>
                                       </>
                                   )
                                   : (
                                       <>
                                           <MainLayout>
                                               <Component {...pageProps}/>
                                           </MainLayout>
                                       </>
                                   )
                               }
                           </AntdConfigProvider>
                       </SessionProvider>
                       {/*<ReactQueryDevtools initialIsOpen={false} />*/}
                   </QueryClientProvider>
               </ReduxProvider>
           </main>
       </>
    )
}
